// frontend/src/components/Login.js

import React, { useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom'; // <-- Убедитесь, что useLocation импортирован
import { TextField, Button, Box, Typography, Alert, CircularProgress } from '@mui/material';
import { AuthContext } from '../context/AuthContext';

const API_BASE_URL = ``;

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation(); // <-- Получаем location

  // Получаем путь, с которого пришел пользователь (если был редирект)
  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const formData = new URLSearchParams();
      formData.append('username', username);
      formData.append('password', password);

      const response = await axios.post(`${API_BASE_URL}/token`, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      const { access_token } = response.data;
      login(access_token);
      // Перенаправляем пользователя на страницу, с которой он пришел, или на главную
      // Используем replace: true, чтобы предотвратить возврат кнопкой "Назад"
      navigate(from, { replace: true }); 
    } catch (err) {
      console.error('Ошибка входа:', err);
      if (err.response) {
        setError(err.response.data.detail || 'Ошибка входа');
      } else if (err.request) {
        setError('Сервер не отвечает.');
      } else {
        setError(`Ошибка запроса: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Вход в систему
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="username"
          label="Имя пользователя"
          name="username"
          autoComplete="username"
          autoFocus
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          disabled={loading}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Пароль"
          type="password"
          id="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={24} /> : null}
        >
          {loading ? 'Вход...' : 'Войти'}
        </Button>
      </Box>
    </Box>
  );
}

export default Login;
